import { EntityType } from "../@core/entityType";
import { Operation } from "reactcoregk";

export const entityType = EntityType.CurrentUser;
export const entityOperations = [Operation.get];
